import { collection, query, getDocs, doc, getDoc, updateDoc, where, serverTimestamp, writeBatch, runTransaction } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { result } from '../utils/result';
import { deleteUser } from 'firebase/auth';
import { apiGate } from '../services/api_gate';
import { deleteOperadorBD } from './userController';


export async function deleteConta(_user) {

  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em deleteConta', _user)
  const batch = writeBatch(db)
  try {
    result.sucess = true
    result.msg = 'Solicitação de Cancelamento de Assinatura encaminhada com sucesso.'
    result.data = _user
    //Desativar e Marcar Conta para processo de exclução

    // Retira do Firebase

    // Apagar participação em contas de terceiros-> contas/terceiro/operadores
    // Documento: contas / id / operadores
    _user.contas.map((cta) => {
      if (cta !== _user.id) {
        const docRef = doc(db, 'contas/' + cta + '/operadores/', _user.id)
        batch.delete(docRef)
      }
      return true
    })



    // Documento: contas / id / knowledge
    // Documento: contas / id / places
    // Documento: usuarios/convites
    // Documento: contas / id
    // Documento: usuarios / id

    // Desativar e Marcar Usuario para processo de exclusão
    // Apagar de Usuarios
    batch.update(doc(db, 'usuarios/' + _user.id), { 'wasdeleted': true, 'deletedat': serverTimestamp(), 'ativo': false })
    batch.update(doc(db, 'contas/' + _user.id), { 'wasdeleted': true, 'deletedat': serverTimestamp(), 'ativo': false })

    // Retira do Postgres
    // Tabela: operador(idconta,idoperador)
    await deleteOperadorBD(_user.conta, _user.id)

    // Apagar token
    localStorage.removeItem('token')
    const message = `Nome: ${_user.nome} \nEmail: ${_user.email} \nTelefone: ${_user.telefone} \nConta: ${_user.id} \nSolicitação: 'Cancelamento de Assinatura e Dados da Conta.'\nPlano:${_user.plano} \nData: ${new Date()}`
    const messageHtml = `<p>Nome: ${_user.nome}</p><p>Email: ${_user.email}</p><p>Telefone: ${_user.telefone}</p><p>Conta: ${_user.id}</p><p>Solicitação: 'Cancelamento de Assinatura e Dados da Conta.'</p><p>Plano:${_user.plano}</p><p>Data: ${new Date()}</p>`
    const email = {
      from: _user.email,
      to: 'financeiro@gate51.com.br',
      subject: 'Solicitação de Cancelamento de Assinatura',
      message: message,
      html: messageHtml,
    }
    const api = await apiGate.post('/email', email)
    if (api.status === 200) {
      await batch.commit();
      // Excluir Usuario do Google Authentication
      await deleteUser(auth.currentUser)
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Email enviado com sucesso.')
    }
    else {
      batch.rollback()
      result.sucess = false
      result.msg = 'Falha ao solicitar Cancelamento de Assinatura, tente novamente mais tarde!'
      result.data = _user
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Falha ao enviar email', api.data)
    }
  }
  catch (e) {
    batch.rollback()
    result.sucess = false
    result.msg = 'Falha ao solicitar Cancelamento de Assinatura, tente novamente mais tarde!'
    result.data = null
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em deleteConta', e)
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saiu de deleteConta', result)
    return result
  }
}

export async function getContaMessage(_conta) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em getContaMessage', _conta)
  let list = [];
  try {
    const q = query(collection(db, "contas/" + _conta + '/mensagens'));
    const queryData = await getDocs(q);
    queryData.forEach((doc) => {
      list.push(doc.data())
    });
    result.sucess = true
    result.data = list
    result.msg = 'Sucesso na operação...'
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em getContaMessage', e)
    result.sucess = false
    result.data = e
    result.msg = 'Falha na operação...'
    return result
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saiu de getContaMessage', result)
    return result
  }
}

export async function getContaController(conta) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em getContaController', conta)
  try {
    const docRef = query(doc(db, 'contas/' + conta))
    const queryData = (await getDoc(docRef)).data();
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saiu de getContaController', queryData)
    return queryData
  } catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em getContaController', e)
    return null
  }
}

export async function getContaConvite(_convite) {
  let contas = [];
  try {
    const q = query(collection(db, "contas"),
      where("convite", "==", _convite),
      where("conviteval", ">=", new Date())
    );
    const queryData = await getDocs(q);
    queryData.forEach((doc) => {
      contas.push(doc.id)
    });
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log(contas, 'data:', new Date(), q)
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log(e)
  }
  finally {
    return contas
  }
}

export async function setCodigoConvite(codigo, validade, conta) {
  try {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou setCodigoConvite', codigo, validade, conta)
    return await updateDoc(doc(db, 'contas', conta), { convite: codigo, conviteval: new Date(validade) })
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Falha setCodigoConvite', e)
  }
}

export async function deleteConta2(_user) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em deleteConta2', _user);

  // Verificar autenticação ANTES de qualquer operação
  if (!auth.currentUser) {
    const authError = {
      success: false,
      msg: 'Usuário não autenticado. Faça login novamente.',
      data: null
    };
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro: usuário não autenticado', authError);
    return authError;
  }

    // Criar resultado local em vez de mutar o global
  const operationResult = {
    success: true,
    msg: 'Solicitação de Cancelamento de Assinatura encaminhada com sucesso.',
    data: _user
  };

  // Validações de entrada
  const errorResult = {
    success: false,
    msg: 'Dados do usuário inválidos ou incompletos.',
    data: null
  };

  
  if (!_user?.id || !_user?.email || !_user?.nome) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro: dados inválidos', errorResult);
    return errorResult;
  }

  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
    console.log('Validações passaram, iniciando processo de exclusão');
    console.log('Usuário autenticado:', auth.currentUser.uid);
  }

  // Verificar e ajustar _user.conta para ser um array
  if (!_user.contas) {
    _user.contas = [];
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('_user.contas era undefined/null, definido como array vazio');
  } else if (!Array.isArray(_user.contas)) {
    _user.contas = [_user.contas];
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('_user.contas não era array, convertido para array:', _user.contas);
  } else {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('_user.contas já é um array:', _user.contas);
  }

  // Preparar e enviar email
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Preparando email de confirmação');
  const message = `Nome: ${_user.nome}\nEmail: ${_user.email}\nTelefone: ${_user.telefone || 'Não informado'}\nConta: ${_user.id}\nSolicitação: 'Cancelamento de Assinatura e Dados da Conta.'\nPlano: ${_user.plano || 'Não informado'}\nData: ${new Date()}`;

  const messageHtml = `
      <p><strong>Nome:</strong> ${_user.nome}</p>
      <p><strong>Email:</strong> ${_user.email}</p>
      <p><strong>Telefone:</strong> ${_user.telefone || 'Não informado'}</p>
      <p><strong>Conta:</strong> ${_user.id}</p>
      <p><strong>Solicitação:</strong> Cancelamento de Assinatura e Dados da Conta.</p>
      <p><strong>Plano:</strong> ${_user.plano || 'Não informado'}</p>
      <p><strong>Data:</strong> ${new Date()}</p>
    `;

  const email = {
    from: _user.email,
    to: 'financeiro@gate51.com.br',
    subject: 'Solicitação de Cancelamento de Assinatura',
    message: message,
    html: messageHtml,
  };

  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Enviando email para:', email.to);
  const api = await apiGate.post('/email', email);

  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Resposta da API de email:', api.status);

  if (api.status === 200) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Email enviado com sucesso, finalizando processo');

    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Iniciando transação do Firestore');

    // Executar transação no Firestore

    const transacao = await runTransaction(db, async (transaction) => {

      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Dentro da transação, lendo documentos');

      // Ler documentos primeiro (obrigatório em transações)
      const userDocRef = doc(db, 'usuarios', _user.id);
      const contaDocRef = doc(db, 'contas', _user.id);

      const userDoc = await transaction.get(userDocRef);
      const contaDoc = await transaction.get(contaDocRef);

      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
        console.log('Documentos lidos - Usuário existe:', userDoc.exists(), 'Conta existe:', contaDoc.exists());
      }

      // Apagar participação em contas de terceiros
      if (_user.contas && _user.contas.length > 0) {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Processando contas de terceiros:', _user.contas);
        
        // Usar for...of em vez de map para operações async dentro da transação
        for (const cta of _user.contas) {
          if (cta !== _user.id) {
            try {
              const operadorDocRef = doc(db, 'contas', cta, 'operadores', _user.id);
              const operadorDoc = await transaction.get(operadorDocRef);
              if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
                console.log('Verificando participação na conta:', cta, 'Operador encontrado:', operadorDoc.exists());
              }
              if (operadorDoc.exists()) {
                transaction.delete(operadorDocRef);
                if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Removido operador da conta:', cta);
              } else {
                if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Operador não encontrado na conta:', cta);
              }
            } catch (operadorError) {
              if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
                console.log('Erro ao processar conta terceira:', cta, operadorError.message);
              }
            }
          }
        }
      } else {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Nenhuma conta de terceiros para processar');
      }

      // Marcar usuário para exclusão (soft delete) - só se existir
      if (userDoc.exists()) {
        transaction.update(userDocRef, {
          'wasdeleted': true,
          'deletedat': serverTimestamp(),
          'ativo': false
        });
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Usuário marcado para exclusão');
      } else {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Documento do usuário não existe, pulando update');
      }

      // Marcar conta para exclusão (soft delete) - só se existir
      if (contaDoc.exists()) {
        transaction.update(contaDocRef, {
          'wasdeleted': true,
          'deletedat': serverTimestamp(),
          'ativo': false
        });
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Conta marcada para exclusão');
      } else {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Documento da conta não existe, pulando update');
      }
      
      // Commit da transação
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Fazendo commit da transação');
      return true
    }).catch((error) => {
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
        console.log('Erro na transação do Firestore:', error.message || error);
        console.log('Código do erro:', error.code);
        // Log específico para erros de permissão 
        if (error.code === 'permission-denied') {
          console.log('ERRO DE PERMISSÃO DETECTADO');
          console.log('Usuário autenticado:', auth.currentUser?.uid);
          console.log('Tentando acessar conta:', _user.id);
          console.log('Email do usuário:', auth.currentUser?.email);
        }
      }
      return false; // Retorna false para indicar falha na transação
    });

    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Transação Firestore concluída, iniciando operações externas', transacao);

    if (!transacao) {
      operationResult.success = false;
      operationResult.msg = 'Falha na transação do Firestore. Operação cancelada.';
      return operationResult;
    }

    // Operações externas 
    // Retira do PostgreSQL
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Removendo operador do PostgreSQL');
    // Handle the case where _user.conta is an array
    if (Array.isArray(_user.contas) && _user.contas.length > 0) {
      // Process each conta in the array
      for (const contaId of _user.contas) {
        try {
          await deleteOperadorBD(contaId, _user.id);
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true'))
            console.log(`Operador removido da conta: ${contaId}`);
        } catch (dbError) {
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true'))
            console.log(`Erro ao remover operador da conta ${contaId}:`, dbError);
          // Continue with other contas even if one fails
        }
      }
    } else if (_user.contas) {
      // Handle single conta case (for backward compatibility)
      await deleteOperadorBD(_user.contas, _user.id);
    }
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Operador removido do PostgreSQL');

    // Remover token do localStorage
    localStorage.removeItem('token');
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Token removido do localStorage');
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
      console.log('Email enviado com sucesso e operações concluídas.');
    }
    return operationResult;
  } else {
    // Se email falhou, não processar a exclusão
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Falha no envio do email, cancelando processo');
    operationResult.success = false;
    operationResult.msg = 'Falha ao enviar email de confirmação. Cancelamento não processado.';
    operationResult.data = { error: api.data, user: _user };

    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) {
      console.log('Falha ao enviar email', api.data);
    }
    return operationResult;
  }

}

